import { Controller } from "@hotwired/stimulus"

// Swaps the feedback form for the "Message sent" confirmation the server
// streams in after a submission, so the sender sees it went through instead
// of a blank form. The web Feedback modal stays on the page after it closes,
// so dismissing there brings back an empty form for the next message.
export default class extends Controller {
  static targets = ["form", "submit", "message"]

  connect() {
    this.submitHTML = this.submitTarget.innerHTML
  }

  messageTargetConnected() {
    this.formTarget.classList.add("hidden")
  }

  dismiss(event) {
    // The modal sits inside the button that opens it.
    event.stopPropagation()

    this.messageTargets.forEach((message) => message.remove())
    this.resetForm()
    this.formTarget.classList.remove("hidden")
    this.dispatch("dismissed")
  }

  resetForm() {
    this.formTarget.reset()
    this.submitTarget.innerHTML = this.submitHTML
    this.submitTarget.disabled = false

    // Let Alpine and the article suggestions catch up with the cleared fields.
    // These don't bubble, so the navigation guard keeps its post-submit baseline
    // and stays off until the next edit.
    for (const field of this.formTarget.elements) {
      field.dispatchEvent(new Event("input"))
      field.dispatchEvent(new Event("change"))
    }
  }
}
